export type WebsiteEventName =
  | "CTA_WAITLIST_CLICKED"
  | "CTA_DEMO_CLICKED"
  | "DEMO_CHOICE_SELECTED"
  | "WAITLIST_SUBMIT_SUCCESS"
  | "WAITLIST_SUBMIT_ERROR"
  | "SECTION_VIEWED";

interface WebsiteEvent {
  name: WebsiteEventName;
  section?: string;
  choice?: string;
}

const analyticsApiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/u, "")
  ?? "https://api.actale.cc";
const analyticsEnabled = import.meta.env.VITE_ANALYTICS_ENABLED !== "false";
const analyticsSessionStorageKey = "actale_website_session";
const viewedSections = new Set<string>();

function sessionKey(): string | null {
  try {
    const existing = window.sessionStorage.getItem(analyticsSessionStorageKey);
    if (existing) return existing;
    const created = window.crypto.randomUUID();
    window.sessionStorage.setItem(analyticsSessionStorageKey, created);
    return created;
  } catch {
    return null;
  }
}

export function trackWebsiteEvent(event: WebsiteEvent): void {
  if (!analyticsEnabled || typeof window === "undefined" || window.navigator.doNotTrack === "1") return;
  const currentSessionKey = sessionKey();
  if (!currentSessionKey) return;

  const payload = {
    eventKey: window.crypto.randomUUID(),
    sessionKey: currentSessionKey,
    name: event.name,
    section: event.section,
    choice: event.choice,
    path: window.location.pathname,
    viewportWidth: Math.round(window.innerWidth),
  };

  void fetch(`${analyticsApiBaseUrl}/api/v1/website-events`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => undefined);
}

export function trackSectionView(section: string): void {
  if (viewedSections.has(section)) return;
  viewedSections.add(section);
  trackWebsiteEvent({ name: "SECTION_VIEWED", section });
}
